
import './App.css';
import WhatsAppFloatingButton from './components/common/WhatsAppFloatingButton';
import Header from './components/header/ManageHeader';

import '@aws-amplify/ui-react/styles.css';
import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, NavLink, useLocation, useNavigate } from 'react-router-dom';

function App() {

    const location = useLocation();
    const [count, setCount] = useState(0);
    const navigate = useNavigate();
    
    useEffect(() => {
        // execute on location change
        setCount(count + 1);
        //console.log(navigate);
        //console.log('Location changed!', location.pathname);
        //console.log('Location changed!', location);
        //console.log('Count', count);
    }, [location]);
    
    
          return (
                    <div className="app">
              
                           <WhatsAppFloatingButton
                        numero="573009210999"
                        mensaje="Estaba en La página de Quality Academics y quiero más información sobre cursos y diplomados"/>     
              
                        <Header navigate={navigate}/>
                    </div>        
      );


}

 
export default (App)